// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"c678b3d1","250":"2a1dbf09","407":"a54c59ad","424":"76afcb0c","436":"041a5447","453":"f394a27d","455":"2b9dbaca","501":"79d5f5d3","595":"3cc69a9c","606":"4bcee00a","691":"109ccc88","821":"3ba74a49","925":"799e394a","969":"b305e07f"}[chunkId] + ".chunk.js";
};